import styled from 'styled-components'
import { CheckIcon } from 'assets/icons/CheckIcon'

export const CheckIconContainer = styled(CheckIcon)`
	font-size: 28px;
	/* fill: ${props => props.theme.primary.main}; */
`
